import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

interface FilterFormState {
  values: FormGroup['value'];

  uiState?: {
    collapsedBoxes?: Record<string, boolean>;
    accordionIndices?: number[] | Record<string, number[]>;
    activeTabIndex?: number;
  };
}

@Injectable({ providedIn: 'root' })
export class FilterFormStateService {
  private state: { [page: string]: FilterFormState } = {};

  setFormState(page: string, state: FilterFormState) {
    this.state[page] = state;
  }

  getFormState(page: string): FilterFormState {
    return this.state[page] || null;
  }

  clearFormState(page: string) {
    //this.state[page] = null;
    delete this.state[page];
  }
}
